import { createAction, handleActions } from 'redux-actions'
import api from '../api'

const GET_SUBSCRIPTIONS = createAction('subscriptions-admin/GET_SUBSCRIPTIONS')
const GET_SUBSCRIPTIONS_SUCCESS = createAction('subscriptions-admin/GET_SUBSCRIPTIONS_SUCCESS')
const GET_SUBSCRIPTIONS_ERROR = createAction('subscriptions-admin/GET_SUBSCRIPTIONS_ERROR')

const DELETE_SUBSCRIPTIONS = createAction('subscriptions-admin/DELETE_SUBSCRIPTIONS')
const DELETE_SUBSCRIPTIONS_SUCCESS = createAction('subscriptions-admin/DELETE_SUBSCRIPTIONS_SUCCESS')
const DELETE_SUBSCRIPTIONS_ERROR = createAction('subscriptions-admin/DELETE_SUBSCRIPTIONS_ERROR')

const CLEAR_SUBSCRIPTIONS = createAction('subscriptions-admin/CLEAR_SUBSCRIPTIONS')

const SELECT_ITEM = createAction('subscriptions-admin/SELECT_ITEM')
const UNSELECT_ITEM = createAction('subscriptions-admin/UNSELECT_ITEM')
const UNSELECT_ALL = createAction('subscriptions-admin/UNSELECT_ALL')
const TOGGLE_ALL = createAction('subscriptions-admin/TOGGLE_ALL')

const SET_PAGE = createAction('subscriptions-admin/SET_PAGE')
const SET_ROWS_PER_PAGE = createAction('subscriptions-admin/SET_ROWS_PER_PAGE')

const SET_SORT = createAction('subscriptions-admin/SET_SORT')
const SET_FILTER = createAction('subscriptions-admin/SET_FILTER')

const initialState = {
  items: [],
  selectedItems: [],
  itemCount: 0,
  allSelected: false,
  loading: false,
  active: null,
  sort: { orderBy: 'customerName', direction: 'asc' },
  filter: {},
  rowsPerPage: 25,
  page: 0,
  searchText: null
}

export default handleActions(
  {
    [GET_SUBSCRIPTIONS]: (state, action) => ({
      ...state,
      searchText: action.payload.searchText,
      loading: true
    }),
    [GET_SUBSCRIPTIONS_SUCCESS]: (state, action) => {
      action.payload.subscriptions.forEach(function (e) {
        e.checked = false
      })
      var items = !state.items.length || action.payload.search
        ? action.payload.subscriptions
        : state.items.concat(action.payload.subscriptions)
      return {
        ...state,
        loading: false,
        items: items,
        itemCount: action.payload.totalCount
      }
    },
    [GET_SUBSCRIPTIONS_ERROR]: (state, action) => ({
      ...state,
      loading: false
    }),
    [DELETE_SUBSCRIPTIONS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [DELETE_SUBSCRIPTIONS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      selectedItems: []
    }),
    [DELETE_SUBSCRIPTIONS_ERROR]: (state, action) => ({
      ...state,
      loading: false
    }),
    [CLEAR_SUBSCRIPTIONS]: (state, action) => ({
      ...state,
      items: []
    }),
    [SELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = true
      state.selectedItems.push({ ...selectedItem })
      var all = state.items && state.selectedItems ? state.items.length === state.selectedItems.length : false

      return {
        ...state,
        items: state.items,
        selectedItems: state.selectedItems,
        allSelected: all
      }
    },
    [UNSELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = false
      var selectedItems = state.selectedItems.filter(function (element) {
        return element.id !== selectedItem.id
      })
      return {
        ...state,
        items: state.items,
        selectedItems: selectedItems,
        allSelected: false
      }
    },
    [UNSELECT_ALL]: (state, action) => ({
      ...state,
      selectedItems: [],
      allSelected: false
    }),
    [TOGGLE_ALL]: (state, action) => {
      var checked = !action.payload
      state.items.forEach(function (item) {
        item.checked = checked
      })
      return {
        ...state,
        items: state.items,
        selectedItems: checked ? [...state.items] : [],
        allSelected: checked
      }
    },
    [SET_PAGE]: (state, action) => ({
      ...state,
      page: action.payload
    }),
    [SET_ROWS_PER_PAGE]: (state, action) => ({
      ...state,
      rowsPerPage: action.payload
    }),
    [SET_SORT]: (state, action) => ({
      ...state,
      sort: { orderBy: action.payload, direction: state.sort.direction === 'asc' ? 'desc' : 'asc' }
    }),
    [SET_FILTER]: (state, action) => {
      let filter = state.filter
      filter[action.payload.name] = action.payload.value
      return { ...state, filter: filter }
    }
  },
  initialState
)

export const getSubscriptions = (searchText = null) => {
  return (dispatch, getState) => {
    const page = getState().subscriptionsAdmin.subscriptions.page
    const rowsPerPage = getState().subscriptionsAdmin.subscriptions.rowsPerPage
    const items = getState().subscriptionsAdmin.subscriptions.items
    if (searchText === null && items.length !== 0 && page * rowsPerPage < items.length) return null
    if (searchText !== null) {
      dispatch(CLEAR_SUBSCRIPTIONS())
    }
    dispatch(GET_SUBSCRIPTIONS({searchText: searchText}))
    return api
      .get(
        'subscriptionsadmin/getSubscriptions',
        '',
        `page=${page}&count=${rowsPerPage}&searchText=${searchText || ''}`
      )
      .then(result => {
        dispatch(GET_SUBSCRIPTIONS_SUCCESS(result))
      })
      .catch(error => {
        dispatch(GET_SUBSCRIPTIONS_ERROR())
        // global message
      })
  }
}

export const search = searchText => {
  return dispatch => {
    dispatch(getSubscriptions(searchText))
  }
}

export const deleteItems = () => {
  return (dispatch, getState) => {
    dispatch(DELETE_SUBSCRIPTIONS())
    const subscriptionIds = getState().subscriptionsAdmin.subscriptions.selectedItems.map(s => s.id)
    return api
      .post('subscriptionsadmin/deleteSubscriptions', null, { subscriptionIds: subscriptionIds })
      .then(result => {
        dispatch(DELETE_SUBSCRIPTIONS_SUCCESS(result))
        dispatch(getSubscriptions())
      })
      .catch(error => {
        dispatch(DELETE_SUBSCRIPTIONS_ERROR(error))
        // global message
      })
  }
}

export const clearSubscriptions = () => {
  return dispatch => {
    dispatch(CLEAR_SUBSCRIPTIONS())
  }
}

export const selectItem = item => {
  return dispatch => {
    dispatch(SELECT_ITEM(item))
  }
}

export const unselectItem = item => {
  return dispatch => {
    dispatch(UNSELECT_ITEM(item))
  }
}

export const unselectAll = () => {
  return dispatch => {
    dispatch(UNSELECT_ALL())
  }
}

export const toggleAll = checked => {
  return dispatch => {
    dispatch(TOGGLE_ALL(checked))
  }
}

export const setSort = value => {
  return dispatch => {
    dispatch(SET_SORT(value))
  }
}

export const setFilter = (name, value) => {
  return dispatch => {
    dispatch(SET_FILTER({ name, value }))
  }
}

export const setPage = value => {
  return dispatch => {
    dispatch(SET_PAGE(value))
  }
}

export const setRowsPerPage = value => {
  return dispatch => {
    dispatch(SET_ROWS_PER_PAGE(value))
  }
}



// WEBPACK FOOTER //
// ./src/store/subscriptions-admin/subscriptions.js